import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import $ from 'jquery';
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import CarouselBox from "./CarouselBox";
import GameBox from "./GameBox";
import { getMemberActionIsRead, getCarousels } from "../../actions/memberActions";
import { getGames } from "../../actions/gameActions";
window.jQuery = window.$ = $;
require('flexslider'); 

class IndexPage extends Component {
  componentDidMount() {
    this.props.getMemberActionIsRead();
    this.props.getGames();
    this.props.getCarousels();
    
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {
    this.sliderMain();
  }

  sliderMain = function () {

    $('#colorlib-hero .flexslider').flexslider({
       animation: "fade",
       slideshowSpeed: 5000,
       directionNav: true,
       start: function () {
          setTimeout(function () {
             $('.slider-text').removeClass('animated fadeInUp');
             $('.flex-active-slide').find('.slider-text').addClass('animated fadeInUp');
          }, 500);
       },
       before: function () {
          setTimeout(function () {
             $('.slider-text').removeClass('animated fadeInUp');
             $('.flex-active-slide').find('.slider-text').addClass('animated fadeInUp');
          }, 500);
       }

    });

  };

  render() {
    const { isRead, carousels, games } = this.props;
    
    let carouselBox;
    if (carousels.length === 0) {
      carouselBox = null;
    } else {
      carouselBox = carousels
        .map(carousel => <CarouselBox key={carousel.idx} carousel={carousel} />);
    }

    let gameBox;
    if (games.length === 0) {
      gameBox = null;
    } else {
      gameBox = games
        .filter(game => game.vip_wire_report_tw>0)
        .map(game => <GameBox key={game.game_id} game={game} />);
    }

    return (
      <div id="page">
        <Navbar showLogin={true} isRead={isRead} />
        <aside className="colorlib-breadcrumbs">
          <div className="container">
          <div className="row">
            <div className="col-md-12 breadcrumbs text-center">
            <h2>直儲中心</h2>
            <p><span>Stored Value Center</span></p>
            </div>
          </div>
          </div>
        </aside>
        {carousels.length > 0 && (
        <aside id="colorlib-hero">
          <div className="container flexslider">
            <ul className="slides">
            {carouselBox}
            </ul>
          </div>
        </aside>
        )}
        <div className="colorlib">
          <div className="container distance">
          <div className="row"> {gameBox}</div>
          </div>
        </div>
        <Footer showAgreement={true} />
      </div>
    );
  }
}

IndexPage.propTypes = {
  getMemberActionIsRead: PropTypes.func.isRequired,
  getCarousels: PropTypes.func.isRequired,
  getGames: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isRead: state.member.isRead,
  carousels: state.member.carousels,
  games: state.games.games,
});

export default connect(mapStateToProps, { getMemberActionIsRead, getGames, getCarousels })(IndexPage);